/*
 * @Descripttion:
 * @version:
 * @Author: 廖图图
 * @Date: 2021-11-16 09:18:11
 * @LastEditors: 廖图图
 * @LastEditTime: 2022-03-23 09:40:52
 */
/**
 * 视图
 */
const view = {
  createViewTree: "/api/createViewTree", //创建
  modifyViewTree: "/api/modifyViewTree", //修改
  deleteViewTree: "/api/deleteViewTree", //删除
  getViewTreeInfo: "/api/getViewTreeInfo", //查询
  getCompanyViewTreesInfo: "/api/getCompanyViewTreesInfo", //查询
  addViewNode: "/api/addViewNode", //添加
  addViewNode2: "/api/addViewNode2", //添加
  addViewNode3: "/api/addViewNode3", //添加
  deleteViewNode: "/api/deleteViewNode", //删除
  deleteViewNode2: "/api/deleteViewNode2", //删除
  getViewNodeInfo: "/api/getViewNodeInfo", //查询
  getViewTreeNodes: "/api/getViewTreeNodes", //查询

  addMeasureContainingItem: "/api/addMeasureContainingItem",
  addMeasureContainingItem2: "/api/addMeasureContainingItem2",
  addMeasureContainingItem3: "/api/addMeasureContainingItem3",
  modifyMeasureContainingItem: "/api/modifyMeasureContainingItem",
  removeMeasureContainingItems: "/api/removeMeasureContainingItems",

  getViewTreeNodesByContainer: "/api/getViewTreeNodesByContainer",
};

export default view;
